import { Pipe, PipeTransform } from '@angular/core';
import { FileSizeUnit } from '../enums/FileSizeUnit';

@Pipe({
	name: 'bytesConversion',
})
export class BytesConversionPipe implements PipeTransform {
	transform(value: number, arg: string): string {
		switch (arg) {
			case FileSizeUnit.BYTES:
				return `${value.toFixed(1)} b`;
			case FileSizeUnit.KILOBYTES:
				return `${(value / 1000).toFixed(1)} kB`;
			case FileSizeUnit.GIGABYTES:
				return `${(value / 1000000).toFixed(1)} gB`;
			case FileSizeUnit.MEGABYTES:
				return `${(value / 1000000000).toFixed(1)} mB`;
			default:
				throw new Error('Unsupported file type!');
		}
	}
}
